import React, { useState } from 'react';
import * as actions from "../../redux/actions";
import { useSelector , useDispatch } from "react-redux";
import arBtn from '../../assets/icons/viewAR.svg';
import { sendAnalyticsData } from "../../utility/levarAnalytics";
import { handleWebViewDetect } from "../../utility/featureDetection";
const BUCKET_URL = process.env.REACT_APP_BUCKET_URL_AR;


const QuickLookBtn = () => {
  const [loading, setLoading] = useState(false);

  const { session_id, hash, variant, referrer, product_id } = useSelector(state => ({
    session_id: state.session_id,
    hash: state.hash,
    variant: state.variant,
    referrer: state.referrer,
    product_id: state.product_id,
  }));

  const dispatch = useDispatch();

  const handleLaunchAR = async (e) => {
    const webCheck = handleWebViewDetect();
    if (webCheck === true) { dispatch(actions.setWebViewPrompt(true)); return }

    e.preventDefault()
    setLoading(true);
    if(session_id) await sendAnalyticsData({ session_id, hash, variant, event_type: 'view_ar_launch', referrer, product_id });
    const anchor = document.createElement('a');
    anchor.setAttribute('rel', 'ar');
    anchor.appendChild(document.createElement('img'));
    anchor.setAttribute('href', `${BUCKET_URL}${hash}.usdz#allowsContentScaling=0`);
    setTimeout(() => {
      anchor.click();
      setLoading(false);
    }, 1000);
  };

  return (
    <div className="LevarUI-IOS">
      <button onClick={(e) => handleLaunchAR(e)}>
        {
          !loading ? (
            <img src={arBtn} alt="Launch in AR"/>
          ) : ( <div className="Loader-IOS"></div> )
        }
      </button>
    </div>
  );
};

export default QuickLookBtn;
